import { FC, useRef } from 'react';
// 组件
import SearchForm from '../SearchForm';
import HighSearch, { HighSearchAction } from './subpage/highSearch';
// 方法
import classnames from 'classnames';
import { getDefauleSearchParams } from '../SuperTable/utils';
import { flterEmptyAndSpace } from '../utils/utils';
import { formDataToValues } from '../utils/dataUtils';
import useSearchForm from './hooks/useSearchTableForm';
import useFormItems from './hooks/useFormItems';
// 常量
import { SearchFormOperationProps } from '../SearchForm/operation';
import { BaseSuperFormProps } from './interface';
import './style.less';

export interface TableFormProps extends BaseSuperFormProps {
  /** 表单最大展示数量 */
  maxItemLength?: number;
  /** 是否展示高级搜索按钮 */
  highSearch?: boolean;
  /** 操作按钮配置 */
  operationProps?: SearchFormOperationProps;
  /** 是否显示边框 */
  showBorder?: boolean;
  /** 高级搜索宽度 */
  highWidth?: number;
  /** 是否显示操作按钮 */
  showOperationButton?: boolean;
  /** 点击重置是触发 */
  onReset?: () => void;
}
/** 搜索框表单 */
export const TableForm: FC<TableFormProps> = props => {
  const {
    className,
    style,
    filterEmpty,
    formType,
    formItems,
    testId,
    actionRef,
    operationProps,
    highWidth,
    highSearch,
    showBorder,
    showOperationButton,
    onFinish,
    onReset,
  } = props;
  const highWrapper = useRef<HTMLDivElement>(null);
  const HighSearchRef = useRef<HighSearchAction | undefined>();
  const { baseFormItems, highFormItems } = useFormItems(
    highWrapper,
    formItems,
    highSearch,
  );
  const findOperation = formItems.find(
    item => item.formItemType === 'Operation',
  );
  const renderChildren = useSearchForm(baseFormItems);
  const handleHighSearch = () => {
    HighSearchRef.current?.show();
  };
  // 重置
  const handleReset = () => {
    HighSearchRef.current?.form?.resetFields();
    onReset && onReset();
  };
  // 普通搜索
  const handleFinish = (values: any) => {
    let highValues = HighSearchRef.current?.form?.getFieldsValue();
    if (!HighSearchRef.current?.form && highFormItems.length) {
      highValues = getDefauleSearchParams({}, highFormItems);
    }
    const newHighValues = flterEmptyAndSpace(highValues);
    const newValues = formDataToValues(
      { ...values, ...newHighValues },
      formItems,
    );
    onFinish && onFinish(newValues);
  };
  // 高级搜索
  const handleHighFinish = (values: any) => {
    const baseValues = actionRef?.current?.getFieldsValue();
    const newBaseValues = flterEmptyAndSpace(baseValues);
    const newValues = formDataToValues(
      { ...values, ...newBaseValues },
      formItems,
    );
    onFinish && onFinish(newValues);
  };
  /** 获取表单的值 */
  const handleGetFieldsValue = () => {
    let highValues = HighSearchRef.current?.form?.getFieldsValue();
    if (!HighSearchRef.current?.form && highFormItems.length) {
      highValues = getDefauleSearchParams({}, highFormItems);
    }
    return {...highValues};
  };
  const classes = classnames('yb-table-form', className, {
    'yb-table-form-border': showBorder,
  });
  return (
    <div className={classes} style={style} ref={highWrapper}>
      <SearchForm
        actionRef={actionRef}
        highActionRef={HighSearchRef.current?.form}
        testId={testId}
        filterEmpty={filterEmpty}
        formType={formType}
        layout="inline"
        wrapperClassName={highSearch ? 'yb-table-high-base-form' : ''}
        getFieldsValue={handleGetFieldsValue}
        onFinish={handleFinish}
        onReset={handleReset}
      >
        {renderChildren}
        {showOperationButton && !findOperation && (
          <SearchForm.Operation
            {...operationProps}
            highSearch={!!highFormItems.length}
            onHighSearch={handleHighSearch}
          />
        )}
      </SearchForm>
      {Array.isArray(highFormItems) && !!highFormItems.length && (
        <HighSearch
          testId={testId}
          highWidth={highWidth}
          formItems={highFormItems}
          actionRef={HighSearchRef}
          onFinish={handleHighFinish}
        />
      )}
    </div>
  );
};

TableForm.defaultProps = {
  formType: 'search',
  maxItemLength: 3,
  highSearch: false,
  defaultLineNumber: 4,
  defaultLabelCol: { span: 8 },
  showBorder: false,
  showOperationButton: true,
};

export default TableForm;
